import React from "react";
import LoadingView from "@/components/ui/loading-view/LoadingView";

const RedditOverviewGate = React.lazy(
  () => import("./RedditOverview.gate")
);

const RedditOverviewLoadable = () => (
  <React.Suspense fallback={<LoadingView />}>
    <RedditOverviewGate />
  </React.Suspense>
);
export default () => <RedditOverviewLoadable />;
